import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { loginUseCase } from "../use-cases/login.use-case";
import { logoutUseCase } from "../use-cases/logout.use-case";
import { LoginRequest } from "../model";
import { useMemberStore } from "../stores/member-store";

/**
 * 로그인 hook
 * useMutation을 사용하여 로그인 처리
 */
export const useLogin = () => {
  const navigate = useNavigate();
  const { setUser } = useMemberStore();

  return useMutation({
    mutationFn: async (credentials: LoginRequest) => {
      return loginUseCase.execute(credentials);
    },
    onSuccess: (data) => {
      // 토큰이 이미 use-case에서 저장됨
      console.log("Login successful", data);

      // 사용자 정보를 Zustand store에 저장
      if (data.user) {
        setUser(data.user);
        console.log("User saved to Zustand store:", data.user);
      }

      // 홈으로 이동
      navigate("/");
    },
    onError: (error: Error) => {
      console.error("Login failed:", error.message);
      // 에러는 컴포넌트에서 처리
      throw error;
    },
  });
};

/**
 * 로그아웃 hook
 */
export const useLogout = () => {
  const navigate = useNavigate();
  const { clearUser } = useMemberStore();

  return useMutation({
    mutationFn: async () => {
      return logoutUseCase.execute();
    },
    onSuccess: () => {
      console.log("Logout successful");

      // Zustand store에서 사용자 정보 제거
      clearUser();

      // localStorage에서 토큰 제거
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("profileId");

      // 로그인 페이지로 이동
      navigate("/login");
    },
    onError: (error: Error) => {
      console.error("Logout failed:", error.message);
    },
  });
};
